export default __webpack_public_path__ + "static/media/topoffers.3242620f.png";